module.exports = __webpack_public_path__ + "static/bakeryslide-07-min-52c1b9cf18800c0e20c522ac53527d3d.jpg";